'use client';

import { useReviewsPageTransportContext } from '@/context/reviews-page.context';

export const ReviewsReconciliationProgressStrip = () => {
    const { isReviewsDataReconciliationRunning = false } = useReviewsPageTransportContext();

    return (
        <div
            data-testid="reviews-reconciliation-progress-strip"
            role={isReviewsDataReconciliationRunning ? 'status' : undefined}
            aria-live={isReviewsDataReconciliationRunning ? 'polite' : undefined}
            aria-hidden={isReviewsDataReconciliationRunning ? undefined : true}
            className="relative h-px w-full overflow-hidden"
        >
            {isReviewsDataReconciliationRunning && (
                <>
                    <span className="sr-only">Идет обновление отзывов и выделения</span>
                    <div aria-hidden="true" className="absolute inset-0 bg-[#dff4fb]" />
                    <div
                        aria-hidden="true"
                        className="absolute inset-0 opacity-55"
                        style={{
                            background:
                                'linear-gradient(90deg, transparent 0%, rgba(56, 189, 248, 0.2) 45%, transparent 100%)',
                        }}
                    />
                    <div
                        aria-hidden="true"
                        className="absolute inset-y-[-1px] left-[-22%] w-[30%]"
                        style={{
                            background:
                                'linear-gradient(90deg, rgba(34, 211, 238, 0), rgba(2, 132, 199, 0.9), rgba(34, 211, 238, 0))',
                            filter: 'blur(0.8px)',
                            animation: 'reviews-reconciliation-signal-rail-sweep 1.6s ease-in-out infinite',
                        }}
                    />
                </>
            )}
            <style jsx global>{`
                @keyframes reviews-reconciliation-signal-rail-sweep {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(420%);
                    }
                }
            `}</style>
        </div>
    );
};
